import React, { Suspense, lazy } from "react";

const Main = lazy(() => import("pages/Main"));
const LandingPage = lazy(() => import("features/landing/LandingPage"));
const SswPage = lazy(() => import("features/ssw/SswPage"));

/**
 * The `/v4` landing page is a standalone entry: it does not use the app
 * shell (header, modals, providers, spotlight tour), so it must not pay
 * for the shell's bundle. Rendering it directly — with `Main` itself
 * lazy — means a landing visitor downloads only the landing chunk.
 * Client-side navigation into `/v4` from inside the shell still works
 * through Main's own route for the path. The `/ssw` school demo page
 * is a standalone entry for the same reason.
 */
function App() {
  const path = window.location.pathname;
  const isLandingEntry = path === "/v4" || path === "/v4/";
  const isSswEntry = path === "/ssw" || path === "/ssw/";
  return (
    <Suspense fallback={<div className="min-h-screen bg-white" />}>
      {isLandingEntry ? <LandingPage /> : isSswEntry ? <SswPage /> : <Main />}
    </Suspense>
  );
}

export default App;
